
import { defineComponent } from "vue";
import { svgNames } from "@/constants/globalConstants";

export default defineComponent({
    props: {
        name: {
            type: String,
            required: true,
        },
    },

    setup() {
        return { svgNames };
    },
});
